/*    
<summary>
   This file is used to provide initial values or state to the Camera Module observables.
   Developer: Mohammad Saquib Khan, Created Date: 12-April-2024
</summary>
*/

import { ICameraListVM } from "../../models/response/ICameraResponse";

export const initialState: ICameraListVM = {
    PagingDetails: {
        TotalRecords: 1,
        TotalPages: 1,
        CurrentPage: 1,
        PageSize: 10,
    },
    Camera: []
}